"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const image_1 = __importDefault(require("next/image"));
const ProductPriceView_1 = require("../../ProductPrice/ProductPriceView");
const ProductInfoWrap = app_1.styled.div `
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  grid-template-rows: 1fr 1fr;
  grid-gap: calc(${(theme) => theme.spacing.extraSmall} * 1.5);
  padding: ${(theme) => theme.spacing.small} 0;
  padding-bottom: 0;
`;
const ProductImageWrap = app_1.styled.div `
  width: 4rem;
  height: 4rem;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid ${(theme) => theme.stroke};
  grid-row: span 2;
`;
const ProductVariantWrap = app_1.styled.div `
  display: flex;
  flex-direction: column;
  line-height: 100%;
  > * {
    font-size: 1rem;
    font-weight: normal;
  }
`;
const ErrorWrap = (0, app_1.styled)(app_1.Text) `
  min-height: ${(theme) => theme.spacing.small};
  color: ${(theme) => theme.colors.error};
`;
const AttributesText = (0, app_1.styled)(app_1.Text) `
  align-items: flex-end;
`;
const StyledLink = (0, app_1.styled)(app_1.Link) `
  font-size: 1rem;
  letter-spacing: 0.025rem;
  font-weight: 500;
  ${app_1.styled.current `
    text-decoration: unset;
  `}
`;
function ProductView({ product, displayCount, className, }) {
    var _a;
    const { t } = (0, app_1.useTranslation)();
    const contextPath = (0, app_1.useContextPath)('ecommerce.product');
    const imgSrc = (product === null || product === void 0 ? void 0 : product.image) &&
        `${contextPath}/${product.productId}/${(_a = product.image) === null || _a === void 0 ? void 0 : _a.name}`;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(ProductInfoWrap, Object.assign({ className: className }, { children: [(0, jsx_runtime_1.jsx)(ProductImageWrap, { children: (0, jsx_runtime_1.jsx)(app_1.Link, Object.assign({ href: `${contextPath}/${product.slug}` }, { children: (0, jsx_runtime_1.jsx)(image_1.default, { src: imgSrc, alt: product.title, layout: "fill", priority: true, sizes: "100px" }) })) }), (0, jsx_runtime_1.jsx)(ProductVariantWrap, { children: (0, jsx_runtime_1.jsxs)(StyledLink, Object.assign({ href: `${contextPath}/${product.slug}` }, { children: [displayCount ? `${product.quantity} x ` : '', product.title] })) }), (0, jsx_runtime_1.jsx)(ProductPriceView_1.ProductPriceView, { quantity: product.quantity, price: product.price, lowestPriceBeforeSale: product.lowestPriceBeforeSale, regularPrice: product.regularPrice }), (0, jsx_runtime_1.jsx)(AttributesText, Object.assign({ tag: "span" }, { children: product.attributes.join(', ') }))] })), (0, jsx_runtime_1.jsx)(ui_1.Animation, Object.assign({ type: "fade", auto: "height" }, { children: (0, jsx_runtime_1.jsx)(ErrorWrap, { children: product.overstock && ((0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span" }, { children: t('store.info.insufficientStock') }))) }) }))] }));
}
exports.ProductView = ProductView;
